"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicFile = exports.getPublicFiles = exports.deleteFileRelation = exports.postFileRelation = exports.putFileOrganization = exports.putFileAccessibility = exports.deleteFilePermission = exports.postFilePermission = exports.searchFiles = exports.postFile = exports.putFile = exports.getFile = exports.getFiles = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var authorizedPath = root_1.mediaAuthorized + '/files/';
var publicPath = root_1.mediaPublic + '/files/';

var getFiles = function getFiles(authentication, queryParameters) {
  return common_1.get(authentication, authorizedPath, queryParameters);
};

exports.getFiles = getFiles;

var getFile = function getFile(authentication, id) {
  return common_1.get(authentication, authorizedPath + id);
};

exports.getFile = getFile;

var putFile = function putFile(authentication, file) {
  return common_1.put(authentication, authorizedPath + file.id, file);
};

exports.putFile = putFile;

var postFile = function postFile(authentication, file) {
  return common_1.post(authentication, authorizedPath, file);
};

exports.postFile = postFile;

var searchFiles = function searchFiles(authentication, queryParameters) {
  return common_1.get(authentication, authorizedPath + 'search', queryParameters);
};

exports.searchFiles = searchFiles;

var postFilePermission = function postFilePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, authorizedPath, id, permission);
};

exports.postFilePermission = postFilePermission;

var deleteFilePermission = function deleteFilePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, authorizedPath, id, permissionId);
};

exports.deleteFilePermission = deleteFilePermission;

var putFileAccessibility = function putFileAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, authorizedPath, id, accessibility);
};

exports.putFileAccessibility = putFileAccessibility;

var putFileOrganization = function putFileOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, authorizedPath, id, organizationId);
};

exports.putFileOrganization = putFileOrganization;

var postFileRelation = function postFileRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, authorizedPath, id, relation);
};

exports.postFileRelation = postFileRelation;

var deleteFileRelation = function deleteFileRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, authorizedPath, id, relationId);
};

exports.deleteFileRelation = deleteFileRelation;

var getPublicFiles = function getPublicFiles(authentication, queryParameters) {
  return common_1.get(authentication, publicPath, queryParameters);
};

exports.getPublicFiles = getPublicFiles;

var getPublicFile = function getPublicFile(authentication, id) {
  return common_1.get(authentication, publicPath + id);
};

exports.getPublicFile = getPublicFile;